<div class="row">
  <div class="col-md-12 customer-tickets">
    <f-data-card class="pos-relative">
      <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
        <f-icon icon-config='{"iconName": "arrows-rotate", "iconType": "solid", "iconSize": "s"}'></f-icon>
      </button>
      <h5>Tickets</h5>
      <section *ngIf="
          (customerAccountService.activeTabDt?.myTodoErrMsg &&
            customerAccountService.activeTabDt?.myTodoErrMsg !== 'NA') ||
          rootScopeService.activeCustTab?.isCustAccCaseManagementErrorEnabled
        " class="error-wrapper">
        <f-alert variant="warning" is-dismissable="true" (alertDismissed)="closeWarning()">
          <p *ngIf="customerAccountService.activeTabDt?.myTodoErrMsg === 'NoData' ">
            No Case Management tool available for the selected client.
          </p>
          <p *ngIf="customerAccountService.activeTabDt?.myTodoErrMsg !== 'NoData' ">
            We can’t connect to Case Management right now, please try again
            later. If the error continues, contact myIT.
          </p>
        </f-alert>
      </section>
      <p *ngIf="!customerAccountService.activeTabDt?.myTodoErrMsg">
        Review any available customer tickets.
      </p>
      <ul>
        <li *ngFor="
            let caseManagement of customerAccountService.activeTabDt?.myTodo
          ">
            <f-button [iconConfig]="iconConfig" class="ih-view-btn" text="Go to {{ caseManagement.heading }}"
            title="Go to {{ caseManagement.heading }}" type="button" variant="action"
            (click)="goToCaseManagement(caseManagement)">
          </f-button>
        </li>
      </ul>
    </f-data-card>
  </div>
</div>